/**
 * Created by Hai Anh on 7/24/19
 */

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from './Button'
import Stepper from './Stepper'
import Checkbox from './Checkbox'

export default ({
	title,
	message,
	buttons,
	closeAlert,
	steps,
	activeStep,
	onStepClick,
	checkbox,
	checkboxText,
	isChecked,
	onCheckboxChange
}) => {
	const renderCheckbox = () => (
		<Checkbox
			label={checkboxText}
			checked={isChecked}
			onChange={onCheckboxChange}
		/>
	)
	return (
		<div className={'alert'}>
			<button className={'icon-container'} onClick={closeAlert}>
				<i className={'fal fa-times icon fa-lg'} />
			</button>
			<h1 className={'alert-title'}>{title}</h1>
			<p className={'alert-message'}>{message}</p>
			{!!checkbox && renderCheckbox()}
			<div className={'buttons-container'}>
				{buttons.map((button, i) => (
					<Button
						onClick={button.onClick}
						key={i}
						text={button.text}
						{...button}
					/>
				))}
			</div>
			{steps != null && (
				<Stepper
					activeStep={activeStep}
					steps={steps}
					onStepClick={onStepClick}
				/>
			)}
		</div>
	)
}
